import { render, staticRenderFns } from "./ExamHistory.vue?vue&type=template&id=60dda16d&scoped=true"
import script from "./ExamHistory.vue?vue&type=script&lang=js"
export * from "./ExamHistory.vue?vue&type=script&lang=js"
import style0 from "./ExamHistory.vue?vue&type=style&index=0&id=60dda16d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dda16d",
  null
  
)

export default component.exports